export function defaultCardConnectSettings() {
    return {
        enabled: false,
        label: "",
        services: [],
        currency: "",
        site: "",
        merchid: "",
        username: "",
        password: "",
    };
}
//# sourceMappingURL=index.js.map